import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { Link, useLocation, useParams } from "react-router-dom";
import { Container, Card, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import { FacebookShareButton, EmailShareButton, LinkedinShareButton, WhatsappShareButton, TwitterShareButton } from "react-share";
import { IoLogoWhatsapp } from "react-icons/io";
import { BsFacebook, BsTwitter, BsLinkedin } from "react-icons/bs";
import { MdMail } from "react-icons/md";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './blc_blog.css';
import MediaQuery from "react-responsive";


//No Hero Section will be here.

const Blc_Blog_Main_new_copy = (props) => {

    // let { id } = useParams();
    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    let query = useQuery();

    const currentBlogId = parseInt(query.get('newsId'));
    const currentBlog = props.valHighlights.blc_news.map(object => object.id).indexOf(currentBlogId);

    const blog = props.valHighlights.blc_news.filter(blog => blog?.id === parseInt(query.get('newsId')))[0];

    // query string formatting
    function formatQuery(str) {
        return str.split(' ').join('-');
    }

    //   Related posts
    const getRelatedPosts = (arr, offset) => [...arr.slice(offset), ...arr.slice(0, offset)];
    const relatedPosts = getRelatedPosts(props.valHighlights.blc_news, currentBlog).slice(1, 4);

    // console.log('All blogs: ', props.valHighlights.blc_news);
    // console.log('current Blog: ', currentBlog);
    // console.log('related Posts: ', relatedPosts);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        swipeToSlide: true,
        initialSlide: 0,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 360,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    // const testUrl = `http://localhost:3000/blchighlights?newsHeading=${query.get('newsHeading')}&newsId=${query.get('newsId')}`
    // console.log('my url: ', testUrl);

    return (
        <div>
            <Card className="bg-dark text-white blog-banner-card">
                <Card.Img src={blog?.blc_news_img.data[0].attributes.url} alt="Card image" className='banner-img' />
                <Card.ImgOverlay className='blog-banner-overlay-container'>

                    <div className="banner-text-overlay">
                        <div className="banner-text-overlay-inner-div">
                            <Container>
                                <Card.Text >
                                    <p className=' fw-bold blog-heading'> {blog?.blc_news_name}</p>
                                </Card.Text>

                                <Card.Text className='my-4'>
                                    <p className='mb-0 blog-date'>{blog?.blc_news_date}</p>
                                </Card.Text>
                            </Container>
                        </div>
                    </div>

                </Card.ImgOverlay>
            </Card>

            <Container>
                <Container className='blogContents-container'>
                    <div className='share-blog w-75 mx-auto' >
                        <div className="social-icons-container">
                            <p className='blog-share-title'>Share</p>
                            <EmailShareButton url={`https://blc.brac.net/blchighlights?newsHeading=${query.get('newsHeading')}&newsId=${query.get('newsId')}`}>
                                <MdMail className='social-icon-email' size={28} />
                            </EmailShareButton>

                            <FacebookShareButton url={`https://blc.brac.net/blchighlights?newsHeading=${query.get('newsHeading')}&newsId=${query.get('newsId')}`}>
                                <BsFacebook className='social-icon-fb' size={25} />
                            </FacebookShareButton>

                            <TwitterShareButton url={`https://blc.brac.net/blchighlights?newsHeading=${query.get('newsHeading')}&newsId=${query.get('newsId')}`}>
                                <BsTwitter className='social-icon-twitter' size={25} />
                            </TwitterShareButton>

                            <LinkedinShareButton url={`https://blc.brac.net/blchighlights?newsHeading=${query.get('newsHeading')}&newsId=${query.get('newsId')}`}>
                                <BsLinkedin className='social-icon-linkedin' size={25} />
                            </LinkedinShareButton>

                            <WhatsappShareButton url={`https://blc.brac.net/blchighlights?newsHeading=${query.get('newsHeading')}&newsId=${query.get('newsId')}`}>
                                <IoLogoWhatsapp className='social-icon-whatsapp' size={30} />
                            </WhatsappShareButton>

                        </div>
                    </div>

                    <div className='blog-contents'>
                        <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}
                            className="news-caption"
                        >
                            {blog?.blc_news}
                        </ReactMarkdown>
                    </div>

                    {/* <div className='blog-contents'>
                        <p className="news-caption">
                            <span className="caption-firstLetter">
                                {blog?.blc_news[0]}
                            </span>
                            <span className="caption-firstLines">
                                {blog?.blc_news.split('.')[0].slice(1)}
                                {blog?.blc_news.split('.')[1]}
                            </span>
                        </p>
                        <p className="news-caption">
                            <span >
                                {blog?.blc_news.split('.').slice(2).join('.')}
                            </span>
                        </p>
                    </div> */}

                </Container>
            </Container>

            <Container className="py-5">
                <Container>
                    <div>
                        {/* <h2>Latest Release</h2> */}
                        <h2 className='text-center text-dark'>Related Posts</h2>

                        <hr style={{ width: '4rem', borderTop: '5px solid #8c8b8b', borderRadius: '10px', marginLeft: 'auto', marginRight: 'auto' }} />
                    </div>
                </Container>
                <Row className='gy-4'>

                    {
                        relatedPosts.map((data, index) => <Col xs={12} sm={6} md={4} key={Math.random()}>
                            <Link
                                to={`/blchighlights?newsHeading=${formatQuery(data.blc_news_name)}&newsId=${data.id}`}
                                className='news-highlight'>
                                <Card className="pricing-animation bg-dark text-white" style={{ width: '100%', border: 'none' }}>
                                    <Card.Img className='relatedPost-thumbnail' src={data.blc_news_img.data[0].attributes.url} alt="Card image" />
                                    <Card.ImgOverlay >
                                        <div className="article-overlay">
                                            <div className="highlight-left">
                                                <h4 className="article-title"><b>{data.blc_news_name}</b></h4>
                                                <p style={{ textAlign: 'left', color: 'gray' }}>{data.blc_news_date}</p>
                                            </div>
                                        </div>
                                    </Card.ImgOverlay>
                                </Card>

                            </Link>

                        </Col>
                        )
                    }


                    {/* <Slider {...settings} className="card__container--inner">
                        {shuffleSlider(props.valHighlights.blc_news).map((data, index) => (
                            <Container key={Math.random()}>
                                <div className="px-2">

                                    <Link
                                        to={`/blchighlights?newsHeading=${formatQuery(data.blc_news_name)}&newsId=${data.id}`}
                                        className='news-highlight'>
                                        <Card className="pricing-animation bg-dark text-white" style={{ width: '100%', border: 'none' }}>
                                            <Card.Img style={{ height: '18rem' }} src={data.blc_news_img.data[0].attributes.url} alt="Card image" />
                                            <Card.ImgOverlay >
                                                <div className="article-overlay">
                                                    <div className="highlight-left">
                                                        <h4 className="article-title"><b>{data.blc_news_name}</b></h4>
                                                        <p style={{ textAlign: 'left', color: 'gray' }}>{data.blc_news_date}</p>
                                                    </div>
                                                </div>
                                            </Card.ImgOverlay>
                                        </Card>

                                    </Link>
                                </div>
                            </Container>
                        ))}
                    </Slider> */}
                </Row>
            </Container>
        </div >
        // <div>
        //     <Card className="bg-dark text-white blog-banner-card">
        //         <Card.Img src={blog?.blc_news_img.data[0].attributes.url} alt="Card image" className='banner-img' />
        //         <Card.ImgOverlay className='blog-banner-overlay-container'>

        //             <div className="banner-text-overlay">
        //                 <div className="banner-text-overlay-inner-div">
        //                     <Container>
        //                         <Card.Text >
        //                             <p className=' fw-bold blog-heading'> {blog?.blc_news_name}</p>
        //                         </Card.Text>

        //                         <Card.Text className='my-4'>
        //                             <p className='mb-0 blog-date'>{blog?.blc_news_date}</p>
        //                         </Card.Text>
        //                     </Container>
        //                 </div>
        //             </div>

        //         </Card.ImgOverlay>
        //     </Card>

        //     <Container>
        //         <Container className='blogContents-container'>
        //             <div className='share-blog' >
        //                 <div className="social-icons-container">
        //                     <p className='blog-share-title'>Share</p>
        //                     <EmailShareButton url={`https://blc.brac.net/blchighlights/${props.valNewsIndex}`}>
        //                         <MdMail className='social-icon-email' size={28} />
        //                     </EmailShareButton>

        //                     <FacebookShareButton url={`https://blc.brac.net/blchighlights/${props.valNewsIndex}`}>
        //                         <BsFacebook className='social-icon-fb' size={25} />
        //                     </FacebookShareButton>

        //                     <TwitterShareButton url={`https://blc.brac.net/blchighlights/${props.valNewsIndex}`}>
        //                         <BsTwitter className='social-icon-twitter' size={25} />
        //                     </TwitterShareButton>

        //                     <LinkedinShareButton url={`https://blc.brac.net/blchighlights/${props.valNewsIndex}`}>
        //                         <BsLinkedin className='social-icon-linkedin' size={25} />
        //                     </LinkedinShareButton>

        //                     <WhatsappShareButton url={`https://blc.brac.net/blchighlights/${props.valNewsIndex}`}>
        //                         <IoLogoWhatsapp className='social-icon-whatsapp' size={30} />
        //                     </WhatsappShareButton>

        //                 </div>
        //             </div>

        //             <div className='blog-contents text-start'>
        //                 <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} className="news-caption">
        //                     {blog?.blc_news}
        //                 </ReactMarkdown>
        //             </div>

        //         </Container>
        //     </Container>

        //     <Container className="py-5">
        //         <Container>
        //             <div>
        //                 <h2>Latest Release</h2>
        //                 <hr />
        //             </div>
        //         </Container>
        //         <div className="card__container">

        //             <Slider {...settings} className="card__container--inner">
        //                 {shuffleSlider(props.valHighlights.blc_news).map((data, index) => (
        //                     <Container key={Math.random()}>
        //                         <div className="px-2">

        //                             <Link
        //                                 to={`/blchighlights?newsHeading=${formatQuery(data.blc_news_name)}&newsId=${data.id}`}
        //                                 className='news-highlight'>
        //                                 <Card className="pricing-animation bg-dark text-white" style={{ width: '100%', border: 'none' }}>
        //                                     <Card.Img style={{ height: '18rem' }} src={data.blc_news_img.data[0].attributes.url} alt="Card image" />
        //                                     <Card.ImgOverlay >
        //                                         <div className="article-overlay">
        //                                             <div className="highlight-left">
        //                                                 <h4 className="article-title"><b>{data.blc_news_name}</b></h4>
        //                                                 <p style={{ textAlign: 'left', color: 'gray' }}>{data.blc_news_date}</p>
        //                                             </div>
        //                                         </div>
        //                                     </Card.ImgOverlay>
        //                                 </Card>

        //                             </Link>
        //                         </div>
        //                     </Container>
        //                 ))}
        //             </Slider>
        //         </div>
        //     </Container>
        // </div>
    );
};

export default Blc_Blog_Main_new_copy;
